export const GET_SUPPLIER_LIST = 'GET_SUPPLIER_LIST';
export const GET_SUPPLIER_LIST_SUCCESS = `${GET_SUPPLIER_LIST}/SUCCESS`;
export const GET_SUPPLIER_LIST_FAILURE = `${GET_SUPPLIER_LIST}/FAILURE`;

export default {
  GET_SUPPLIER_LIST,
  GET_SUPPLIER_LIST_SUCCESS,
  GET_SUPPLIER_LIST_FAILURE
};
